//Confirmation popup if user triggers the app deletion button
import React, { useState } from "react";
import PortalOverlay from "../../../../Shared/portal-overlay/portalOverlay";
import Styles from "../../../../Shared/popup.module.scss";
import Button from "../../../../Shared/button/button";
import {
  cancelButtonStyle,
  dangerButtonStyle,
  cancelButtonHoverStyle,
  dangerButtonHoverStyle,
} from "../../../../Shared/buttonStyles";
import { MEDIUM } from "../../../../Shared/buttonSize";
import { callApi } from "../../../../api/fetch";
import { DANGER } from "../../../../Shared/colors";
import { useNavigate } from "react-router-dom";

function DeleteApp({ onCancel, appId }: any) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const history = useNavigate();
  function handleCancel(event: any) {
    event.preventDefault();
    onCancel();
    return;
  }
  async function handleDeleteAppAuthentication(event: any) {
    event.preventDefault();
    try {
      setLoading(true);
      await callApi(`/apps/${appId}`, { method: "DELETE" });
      setLoading(false);
      history("/application/manage-apps");
    } catch (err) {
      setLoading(false);
      setError((err as Error).message);
    }
    return;
  }
  return (
    <PortalOverlay>
      <div
      className={`d-flex align-items-center justify-content-center ${Styles.overlay}`}
    >
      <div className={`p-4 ${Styles.popUpContent}`}>
        <form>
          <div className="py-4">
            <p className={`mb-0 ${Styles.warningMessage} text-center`}>
              Are you sure you want to Delete this App.
            </p>
          </div>
          <div className="d-flex align-items-center py-3 justify-content-around">
            <div className="px-2">
              <Button
                id={`manage-apps-delete-app-cancel-${appId}`}
                size={MEDIUM}
                hoveredStyle={cancelButtonHoverStyle}
                style={cancelButtonStyle}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
            <div className="px-2">
              <Button
                id={`manage-apps-delete-app-continue-${appId}`}
                size={MEDIUM}
                isLoading={loading}
                hoveredStyle={dangerButtonHoverStyle}
                style={dangerButtonStyle}
                onClick={handleDeleteAppAuthentication}
              >
                Continue
              </Button>
            </div>
          </div>
          {error && (
            <div className="py-2">
              <p
                className="mb-0 text-center"
                style={{ color: DANGER, fontSize: "12px" }}
              >
                {error}
              </p>
            </div>
          )}
        </form>
      </div>
    </div></PortalOverlay>
  );
}

export default DeleteApp;
